<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-simple-table class="table-layout border-table">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left px-4">Loại hình</th>
                                <th class="text-left">Contact (Lead)</th>
                                <th class="text-left">Đơn hàng</th>
                                <th class="text-left">CR</th>
                                <th class="text-left">APRU</th>
                                <th class="text-left">Tỷ lệ chốt thành công</th>
                                <th class="text-left">Doanh thu khởi tạo</th>
                                <th class="text-left"> Gross sale</th>
                                <th class="text-left">Doanh thu thành công</th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length">
                            <tr>
                                <th class="text-left">
                                    <span style="font-size:20px">Tổng</span>
                                </th>
                                <td class="text-right">{{ formatPrice(Math.round(total.totalContact)) }}</td>
                                <td class="text-right">{{ formatPrice(total.totalOrder) }}</td>
                                <td class="text-right">{{ formatPrice(Math.round(total.cr*100)) }}%</td>
                                <td class="text-right">
                                    <!-- <span v-if="parseInt(total.totalOrder) > 0 && total.initTurnOver !== null">
                                       {{ formatPrice(Math.round(total.initTurnOver / total.totalOrder)) }}
                                    </span> -->
                                    <span>{{formatPrice(total.arpu) || 0}}</span>
                                </td>
                                <!-- <td>{{ formatPrice(total.arpu) }}</td> -->
                                <td class="text-right">
                                    <span v-if="total.totalContact > 0">{{ ((total.totalSuccessOrder / total.totalContact)*100).toFixed(1) }}%</span>
                                </td>
                                <td class="text-right">{{ formatPrice(Math.round(total.initTurnOver)) }}</td>
                                <td class="text-right">{{ formatPrice(Math.round(total.grossSale)) }}</td>
                                <td class="text-right">{{ formatPrice(Math.round(total.successTurnOver)) }}</td>
                            </tr>
                            <template v-for="(item, index) in data">
                                <tr :key="index">
                                    <th class="text-left">
                                        {{ item.name }}
                                    </th>
                                    <td class="text-right">{{ formatPrice(item.totalContact) }}</td>
                                    <td class="text-right">{{ formatPrice(item.totalOrder) }}</td>
                                    <td class="text-right">{{ formatPrice(Math.round(item.cr*100)) }}%</td>
                                    <td class="text-right">
                                        <!-- <span v-if="parseInt(item.totalOrder) > 0 && item.initTurnOver !== null">
                                            {{ formatPrice(Math.round(item.initTurnOver / item.totalOrder)) }}
                                        </span> -->
                                        <span>{{formatPrice(item.arpu) || 0}}</span>
                                    </td>
                                    <!-- <td>{{ formatPrice(item.arpu) }}</td> -->
                                    <td class="text-right">
                                        <span v-if="item.totalContact > 0">{{ ((item.totalSuccessOrder / item.totalContact)*100).toFixed(1) }}%</span>
                                    </td>
                                    <td class="text-right">{{ formatPrice(Math.round(item.initTurnOver)) }}</td>
                                    <td class="text-right">{{ formatPrice(Math.round(item.grossSale)) }}</td>
                                    <td class="text-right">{{ formatPrice(Math.round(item.successTurnOver)) }}</td>
                                </tr>

                                <tr class="row-child" v-for="(item_child, idx) in item.schoolLevels" :key="`key${index}${idx}`">
                                    <th class="text-left">
                                        <span>{{ item_child.schoolLevelName }}</span>
                                    </th>
                                    <td class="text-right">{{ formatPrice(item_child.totalContact) }}</td>
                                    <td class="text-right">{{ formatPrice(item_child.totalOrder) }}</td>
                                    <td class="text-right">{{ formatPrice(Math.round(item_child.cr*100)) }}%</td>
                                    <td class="text-right">
                                        <!-- <span v-if="parseInt(item_child.totalOrder) > 0">
                                           {{ formatPrice(Math.round(item_child.initTurnOver / item_child.totalOrder)) }}
                                        </span> -->
                                        <span>{{formatPrice(item_child.arpu) || 0}}</span>
                                    </td>
                                    <!-- <td>{{ formatPrice(item_child.arpu) }}</td> -->
                                    <td class="text-right">
                                        <span v-if="item_child.totalContact > 0">{{ ((item_child.totalSuccessOrder / item_child.totalContact)*100).toFixed(1) }}%</span>
                                    </td>
                                    <td class="text-right">{{ formatPrice(Math.round(item_child.initTurnOver)) }}</td>
                                    <td class="text-right">{{ formatPrice(Math.round(item_child.grossSale)) }}</td>
                                    <td class="text-right">{{ formatPrice(Math.round(item_child.successTurnOver)) }}</td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="1000">
                                    <common-no-result />
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => {[]}
        },
        total: {
            type: Object,
            default: () => {}
        },
        // tab: {
        //     type: Number,
        //     default: 0
        // }
    }
}
</script>

<style scoped>
/deep/ .v-data-table {
  border: 1px solid #D7D3F2 !important;
  border-radius: 10px;
}

/deep/ .v-data-table tbody:hover td, .v-data-table tbody:hover th {
  background: white;
}

/deep/ .v-data-table tbody td {
  font-size: 16px;
  font-weight: 400;
  border-bottom: thin solid #D7D3F2 !important;
  border-right: thin solid #D7D3F2 !important;
}

/deep/ .v-data-table tbody tr td:first-child {
  border-right: none;
}

/deep/ .v-data-table tbody tr {
  height: 60px !important;
}

/deep/ .v-data-table tbody tr th {
    border-right: thin solid #D7D3F2 !important;
    border-bottom: thin solid #D7D3F2 !important;
    /* color: #4C458D !important; */
    font-size: 16px !important;
    font-weight: 500 !important;
}

/deep/ .v-data-table thead tr th {
    border-right: thin solid #D7D3F2 !important;
    border-bottom: thin solid #D7D3F2 !important;
    color: hsl(0, 0%, 33.3%) !important;
    background: hsl(248.6, 36.8%, 96.3%) !important;
    font-size: 16px !important;
    font-weight: 500 !important;
}

/deep/ .v-data-table tbody tr td:first-child {
    /*border-right: none !important;*/
}

/deep/ .v-data-table thead tr th:first-child {
    border-top-left-radius: 10px;
}

/deep/ .v-data-table thead tr th:last-child {
    border-top-right-radius: 10px;
}

/deep/ .v-data-table tbody tr:first-child th {
    border-bottom: none !important;
    background: hsl(0, 0%, 91.8%) !important;
    font-weight: bold !important;
}

/deep/ .v-data-table tbody tr:last-child th {
    border-bottom-left-radius: 10px;
}

/deep/ .v-data-table tbody tr:first-child td {
    border-bottom: none !important;
    background: hsl(0, 0%, 91.8%) !important;
    font-weight: bold !important;
}

/deep/ .v-data-table tbody tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}

/deep/ .row-child th {
    padding-left: 30px !important;
    background: hsl(0, 0%, 91.8%) !important;
}

/deep/ .row-child td {
    background: hsl(0, 0%, 91.8%) !important;
}
</style>